import styled from 'styled-components'

import { media } from 'styles/media'

import ButtonLink from 'components/display/ButtonLink'
import VideoButton from 'components/branding/VideoButton'

import { CallToActionButton, Title } from '../shared'

import StoriesIllustrationFigure from './StoriesIllustrationFigure'

const IntroTitle = styled(Title).attrs({
  noLeftMargin: true,
})`
  margin-bottom: 16px;
  line-height: 1.2;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-xxl']['font-size'].value};
  `}
`

const Paragraph = styled.p`
  color: ${({ theme }) => theme['-ds-core-300'].value};
  font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  line-height: 1.5;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};
    line-height: 1.7;
  `}
`

const TextWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 56px;

  ${media.lg`
    max-width: 600px;
    padding: 0;
    margin-bottom: 0;
  `}

  ${CallToActionButton} {
    margin: 9px 0 0 0;

    ${media.md`
      margin: 24px 0 0 0;
    `}
  }
`

const Half = styled.div`
  ${media.lg`
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`

const Outer = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${media.md`
    flex-direction: row;
    justify-content: space-between;
  `}
`

type IntroProps = {
  illustrationImage?: {
    medium: string
    large: string
  }
}

const Intro = ({ illustrationImage }: IntroProps) => {
  return (
    <Outer>
      <Half>
        <TextWrapper>
          <IntroTitle>Live fully with Riparide</IntroTitle>
          <Paragraph>
            We help you plan and book your next nature escape through our
            storyteller travel guides. These guides, which we call Riparide
            Stories, come packed with unique stays and adventure advice to
            inspire you to pursue fulfilling moments in nature.
          </Paragraph>
          <div style={{ display: 'flex', gap: '16px', marginTop: '24px' }}>
            <ButtonLink uppercase={false} href="/stories-travellers">
              Learn more
            </ButtonLink>
            <VideoButton>Watch video</VideoButton>
          </div>
        </TextWrapper>
      </Half>
      <Half>
        <StoriesIllustrationFigure illustrationImage={illustrationImage} />
      </Half>
    </Outer>
  )
}

export default Intro
